import Option from '@/components/form/types/Option.ts';
import {
  FieldDefinitionDto,
  TableDefinitionDto,
} from '@/components/table/types/TableDefinitionDto.ts';
import { useFormContext } from 'react-hook-form';
import { FilterCriteriaForm } from '@/components/table/schemas/filterCriteriaSchema.ts';
import { fieldsConfig } from '@/components/table/_fieldDefinitions/fieldsConfig.ts';
import React, { useState } from 'react';
import SingleSelectInput from '@/components/form/SingleSelectInput.tsx';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import { Trash } from 'lucide-react';
import { FilterCombinator } from '@/components/table/components/filter/FilterCombinator.tsx';
import { operatorDisplayName } from '@/components/table/_filterFieldOperators/filterFieldDisplayNames.ts';

export const SingleFilterRow = ({
  index,
  filterOptions,
  tableDef,
  remove,
  filtersNumber,
}: {
  index: number;
  filterOptions: Option[];
  tableDef: TableDefinitionDto;
  remove: (index: number) => void;
  filtersNumber: number;
}) => {
  const form = useFormContext<FilterCriteriaForm>();

  const fieldValue = form.watch(`filters.${index}.fieldId`);

  const fieldDef = tableDef.fields.find((f) => f.fieldId === fieldValue);
  const config = fieldDef ? fieldsConfig[fieldDef.type] : null;
  const InputComponent = config?.component;

  const [operatorOptions, setOperatorOptions] = useState<Option[]>(
    mapOperators(fieldDef),
  );

  function mapOperators(fieldDef?: FieldDefinitionDto) {
    if (!fieldDef || fieldDef.operators.length === 0) return [];
    return fieldDef.operators.map((op) => ({
      value: op,
      label: operatorDisplayName(op),
    }));
  }

  const onFieldIdChange = (fieldId: string) => {
    const fieldDef = tableDef.fields.find((field) => field.fieldId === fieldId);
    if (!fieldDef) return;

    const operators = mapOperators(fieldDef);
    setOperatorOptions(operators);

    form.setValue(`filters.${index}.operator`, operators[0]?.value);
    form.setValue(`filters.${index}.type`, fieldDef.type);
  };

  return (
    <div className="flex flex-row items-center gap-2">
      {filtersNumber > 1 && (
        <div className="w-[100px]">
          <FilterCombinator index={index} />
        </div>
      )}
      <div className="grid w-full grid-cols-[3fr_2fr_5fr_30px] gap-2 rounded-md bg-neutral-50 p-1">
        <SingleSelectInput
          controlSize="toolbar"
          fieldName={`filters.${index}.fieldId`}
          control={form.control}
          options={filterOptions}
          onChange={onFieldIdChange}
          mobileMenuTitle="Pole"
        />
        {fieldValue ? (
          <>
            <SingleSelectInput
              controlSize="toolbar"
              fieldName={`filters.${index}.operator`}
              control={form.control}
              options={operatorOptions}
              mobileMenuTitle="Warunek"
            />
            {InputComponent && (
              <InputComponent form={form} index={index} fieldDef={fieldDef} />
            )}
          </>
        ) : (
          <>
            <div />
            <div />
          </>
        )}
        <ActionButton
          tone="dangerGhost"
          size="toolbar"
          iconOnly
          aria-label="Usuń filtr"
          onClick={() => remove(index)}
        >
          <Trash />
        </ActionButton>
      </div>
    </div>
  );
};
